import api from '../../../App/socket';
import { uploadImage } from '../../../App/requests/upload_image_request';

export const getLeadProfilePhotos = (_id) => api.send({
    api: 'db',
    model: 'Lead',
    action: 'Read',
    options: {
        limit: 1,
        attributes: 'all',
        where: {
            _id,
        },
    },
});

export const uploadLeadProfilePhoto = (_id, kind, picture, blemish_report_question) => uploadImage({
    _id,
    kind,
    picture,
    blemish_report_question,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/lead_profile_photos_request.js